<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          name="salutation"
          :value="person.salutation"
          :label="$t('PROFILE.SALUTATION')"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          name="first_name"
          :value="employee.first_name"
          :label="$t('PROFILE.FIRST_NAME')"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          name="last_name"
          :value="employee.last_name"
          :label="$t('PROFILE.LAST_NAME')"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          name="language"
          :value="language.locale"
          :label="$t('PROFILE.LANGUAGE')"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          name="gender"
          :value="person.gender"
          :label="$t('PROFILE.GENDER')"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          name="date_birth"
          :value="employee.date_birth | dateFormat"
          :label="$t('PROFILE.BIRTH_DATE')"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row class="mt-3">
      <v-col cols="12" md="4">
        <v-text-field
          name="street"
          :value="employee.street"
          :label="$t('PROFILE.STREET')"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <zip-code-input v-model="employee.zip" readonly />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          name="city"
          :value="employee.city"
          :label="$t('PROFILE.CITY')"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { dateFormat } from '@/modules/_global/filters';
import ZipCodeInput from "@/modules/_global/_components/zip/ZipCodeInput";

export default {
  name: 'EmployeeMainInformationForm',
  components: {ZipCodeInput},
  filters: {
    dateFormat
  },

  props: {
    person: {
      type: Object,
      default: () => ({})
    },
    employee: {
      type: Object,
      default: () => ({})
    },
    language: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
